import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-visibility"
export default class extends Controller {
  static targets = ["trigger", "content"]

  toggle() {
    const isChecked = this.triggerTarget.checked
    this.contentTargets.forEach(target => {
      target.classList.toggle('d-none', !isChecked)
    })
  }
}
